export default {
  multipleMarketWeekendDeliveryTriggerSetUp: {
    id: 'bo_seller.options.shipping.multiple_market_weekend_delivery.trigger.set_up',
    defaultMessage: 'Set up now',
  },
  multipleMarketWeekendDeliveryTriggerUpdate: {
    id: 'bo_seller.options.shipping.multiple_market_weekend_delivery.trigger.update',
    defaultMessage: 'Update weekend delivery',
  },
  multipleMarketWeekendDeliveryDrawerHeadline: {
    id: 'bo_seller.options.shipping.multiple_market_weekend_delivery.drawer.headline',
    defaultMessage: 'Manage weekend delivery',
  },
  multipleMarketWeekendDeliveryDrawerInstruction: {
    id: 'bo_seller.options.shipping.multiple_market_weekend_delivery.drawer.instruction',
    defaultMessage:
      'Select shipping providers that deliver on weekends by market.',
  },
  multipleMarketWeekendDeliveryConfigurationFormSubmitButton: {
    id: 'bo_seller.options.shipping.multiple_market_weekend_delivery.configuration_form.submit_button',
    defaultMessage: 'Save changes',
  },
  multipleMarketWeekendDeliveryConfigurationFormTableHeadline: {
    id: 'bo_seller.options.shipping.multiple_market_weekend_delivery.configuration_form.table_headline',
    defaultMessage: 'Market',
  },
  multipleMarketWeekendDeliveryConfigurationFormTableHeadSelectAll: {
    id: 'bo_seller.options.shipping.multiple_market_weekend_delivery.configuration_form.table_head_select_all',
    defaultMessage: 'Select all',
  },
}
